import { showToastMessage } from '../videoUploadUtils';
import { ACM } from '../../../constants/UserRoles';

const useUploadValidation = () => {
  const validateVideoUpload = (
    uploadedFile,
    date,
    selectedPatient,
    selectedStudent,
    therapyType,
    antecedent,
    consequence,
    interventions,
    goalAssociatedWithBehavior,
    selectedGoalIds,
    selectCategory,
    selectedBehaviorIds,
    selectedSkillIds,
    otherInputValue,
    information,
    typeOfUser,
    setError
  ) => {
    // Validation
    const errors = {};
    if (!uploadedFile) errors.uploadedFile = 'Please select a file to upload.';
    if (!date) errors.date = 'Please select a valid date.';
    else if (date >= new Date())
      errors.date = 'The selected date must be in the past.';
    if (
      ACM[typeOfUser]?.isDoctor &&
      !ACM[typeOfUser]?.isTeacher &&
      !selectedPatient
    )
      errors.selectedPatient = 'Please select a patient.';
    if (ACM[typeOfUser]?.isTeacher && !selectedStudent)
      errors.selectedStudent = 'Please select a student.';
    if (!therapyType || therapyType.trim() === '')
      errors.therapy = 'Please enter a therapy type.';
    if (!antecedent || antecedent.trim() === '')
      errors.antecedent = 'Please enter an antecedent.';
    if (!consequence || consequence.trim() === '')
      errors.consequence = 'Please enter a consequence.';
    if (!interventions || interventions.trim() === '')
      errors.interventions = 'Please enter an intervention.';
    if (goalAssociatedWithBehavior && selectedGoalIds.length === 0)
      errors.goalsSelected = 'Please select at least one goal.';
    if (!goalAssociatedWithBehavior) {
      if (selectCategory === 'Behavior' && selectedBehaviorIds.length === 0)
        errors.behaviorsSelected = 'Please select at least one behavior.';
      if (
        selectCategory === 'Skill Acquisition' &&
        selectedSkillIds.length === 0
      )
        errors.skillSelected = 'Please select at least one skill.';
      if (selectCategory === 'Other' && !otherInputValue)
        errors.other = 'Please enter a value for the "Other" category.';
    }
    if (!information.notes || information.notes.trim() === '')
      errors.other =
        'Please enter a description of events leading up to this behavior.';

    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((msg) => showToastMessage('error', msg));
      setError({ show: true, message: 'Please fix the highlighted errors.' });
      return false;
    }

    return true;
  };

  return {
    validateVideoUpload,
  };
};

export default useUploadValidation;
